import { useState } from "react";
import { entryLinks, lastUpdated } from "@/mocks/home";

export default function Hero() {
  const [copied, setCopied] = useState("");
  const quick = entryLinks.slice(0, 3);

  const copyDomain = async (domain: string) => {
    try {
      await navigator.clipboard.writeText(domain);
    } catch {
      const el = document.createElement("textarea");
      el.value = domain;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(domain);
    window.setTimeout(() => setCopied(""), 1800);
  };

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20abstract%20cinema%20background%20with%20glowing%20film%20projector%20light%20beams%2C%20film%20reel%20silhouette%20and%20golden%20bokeh%20particles%2C%20deep%20amber%20and%20crimson%20tones%2C%20dramatic%20dark%20vignette%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=1920&height=1080&seq=cinema-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/55 to-black/80"></div>
      </div>

      <div className="relative mx-auto w-full max-w-content px-4 py-16 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-medium text-white backdrop-blur">
          <i className="ri-tv-2-line text-primary-300"></i>
          官方入口导航 · 每日更新
        </span>

        <h1 className="mt-5 max-w-3xl font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
          星辰影院官网最新入口
          <span className="mt-2 block text-xl text-primary-300 md:text-3xl">
            打不开？这里有可用地址、APP 下载与解决方法
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          本站整理星辰影院当前可用的访问入口、各端 APP 下载方式，以及网址失效、域名被屏蔽时的解决办法。
          无论你换了设备还是切换了网络，都能在这里第一时间找到可用入口，继续畅快观影。
        </p>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#entry"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-link-m"></i>
            查看最新可用入口
          </a>
          <a
            href="#download"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10"
          >
            <i className="ri-download-2-line"></i>
            APP 客户端下载
          </a>
        </div>

        <div className="mt-10 w-full overflow-hidden rounded-lg border border-white/15 bg-white/10 p-4 backdrop-blur-md md:p-5">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-white">
              <i className="ri-flashlight-line text-primary-300"></i>
              当前可用入口（快速复制）
            </span>
            <span className="text-xs text-white/70">
              更新于 {lastUpdated.date} {lastUpdated.time}
            </span>
          </div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {quick.map((item) => (
              <div
                key={item.id}
                className="flex items-center justify-between gap-3 rounded-md border border-white/15 bg-black/25 px-3 py-2.5"
              >
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span
                      className={
                        item.status === "正常"
                          ? "h-2 w-2 rounded-full bg-primary-400"
                          : "h-2 w-2 rounded-full bg-accent-400"
                      }
                    ></span>
                    <span className="truncate text-sm font-medium text-white">
                      {item.name}
                    </span>
                  </div>
                  <span className="mt-0.5 block truncate text-xs text-white/70">
                    {item.domain}
                  </span>
                </div>
                <button
                  type="button"
                  onClick={() => copyDomain(item.domain)}
                  className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md bg-white/15 text-white transition-colors hover:bg-white/25"
                  aria-label={`复制 ${item.domain}`}
                >
                  <i
                    className={
                      copied === item.domain ? "ri-check-line" : "ri-file-copy-line"
                    }
                  ></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}